import { Upload } from 'lucide-react';
import styles from './FileDropZone.module.css';

export const CSV_FILES = '.csv,text/csv';

export type FileDropZoneProps = {
  accept: string;
  label: string;
  helperText: string;
  onFile: (file: File) => void;
};

export const FileDropZone = ({ accept, label, helperText, onFile }: FileDropZoneProps) => (
  <label
    className={styles['dropzone']}
    onDragOver={(event) => {
      event.preventDefault();
    }}
    onDrop={(event) => {
      event.preventDefault();
      const [file] = event.dataTransfer.files;
      if (file !== undefined) onFile(file);
    }}
  >
    <input
      type="file"
      accept={accept}
      aria-label={label}
      className="visually-hidden"
      onChange={(event) => {
        const [file] = event.target.files ?? [];
        if (file !== undefined) onFile(file);
        event.target.value = '';
      }}
    />
    <Upload size={20} aria-hidden="true" />
    <strong>{label}</strong>
    <span className={styles['help']}>{helperText}</span>
  </label>
);
